import { type ChangeEvent, createContext, type FC, type MouseEvent, type ReactElement, useState } from 'react';
import { usePagination } from '../content/hooks';
import type { Order, RoleModel, RoleSortingFields } from '../models';

interface IRolesContext {
  rolesUpdate: boolean;
  toggleRolesUpdate: () => void;
  roles: RoleModel[];
  setRoles: (val: RoleModel[]) => void;
  page: number;
  setPage: (val: number) => void;
  limit: number;
  setLimit: (val: number) => void;
  count: number;
  setCount: (val: number) => void;
  order: Order;
  setOrder: (val: Order) => void;
  orderBy: RoleSortingFields;
  setOrderBy: (val: RoleSortingFields) => void;
  handlePageChange: (_event: any, newPage: number) => void;
  handleLimitChange: (event: ChangeEvent<HTMLInputElement>) => void;
  handleRequestSort: (_event: MouseEvent, property: RoleSortingFields) => void;
  loading: boolean;
  setLoading: (val: boolean) => void;
}

export const RolesContext = createContext<IRolesContext>({} as IRolesContext);

export const RolesProvider: FC<{ children: ReactElement }> = ({ children }) => {
  const [rolesUpdate, setRolesUpdate] = useState(false);
  const toggleUpdate = (): void => setRolesUpdate(!rolesUpdate);

  const {
    page,
    setPage,
    limit,
    setLimit,
    count,
    setCount,
    order,
    setOrder,
    orderBy,
    setOrderBy,
    handlePageChange,
    handleLimitChange,
    handleRequestSort
  } = usePagination<RoleSortingFields>(toggleUpdate, 'displayName', 'desc');

  const [roles, setRoles] = useState<RoleModel[]>([]);
  const [loading, setLoading] = useState(false);

  return (
    <RolesContext.Provider
      value={{
        rolesUpdate,
        toggleRolesUpdate: toggleUpdate,
        roles,
        setRoles,
        page,
        setPage,
        limit,
        setLimit,
        count,
        setCount,
        order,
        setOrder,
        orderBy,
        setOrderBy,
        handlePageChange,
        handleLimitChange,
        handleRequestSort,
        loading,
        setLoading
      }}
    >
      {children}
    </RolesContext.Provider>
  );
};
